// Save buttons that lock themselves on click, so a slow save cannot be sent twice:
//   - `disable-on-submit` locks the button that was clicked.
//   - `disable-all-on-submit` locks every `disable-btn-on-submit` button on the page.
//
// The click is turned into a `submit` event on the form, then `form.submit()`. The event does not bubble, so Rails
// UJS (listening on the document) never takes the submission over, but it IS cancelable: a listener on the form can
// hold the submission (the auto-save session check, the legal guardian email confirmation) and the buttons are
// handed back. That listener then owns the form and submits it itself when it is ready. The event used to be
// uncancelable and `form.submit()` ran regardless, so those guards were silently skipped.

const SPINNER = '<i class="bi bi-spinner bi-spin"></i> Submitting...';

function lock(buttons) {
  return buttons.map((button) => {
    const html = button.innerHTML;
    button.dataset.originalHtml = html;
    button.disabled = true;
    button.innerHTML = SPINNER;
    return { button, html };
  });
}

function release(locked) {
  locked.forEach(({ button, html }) => {
    button.disabled = false;
    button.innerHTML = html;
  });
}

// A button can join a form from outside it through its `form` attribute (the legacy visit note Save does).
function formFor(button) {
  return button.form || button.closest('form');
}

function submitUnlessHeld(clickEvent, buttons) {
  clickEvent.preventDefault();
  const form = formFor(clickEvent.currentTarget);
  const locked = lock(buttons);

  if (!form?.checkValidity()) {
    release(locked);
    form?.reportValidity();
    return;
  }

  const proceed = form.dispatchEvent(new Event('submit', { cancelable: true }));
  if (proceed) {
    form.submit();
  } else {
    release(locked);
  }
}

function disableOnSubmitHandler(clickEvent) {
  submitUnlessHeld(clickEvent, [clickEvent.currentTarget]);
}

function disableAllOnSubmitHandler(clickEvent) {
  submitUnlessHeld(clickEvent, Array.from(document.querySelectorAll('.disable-btn-on-submit')));
}

// Safe to call on every page load: removing first keeps a button from collecting a second listener.
export function installDisableOnSubmit(root = document) {
  root.querySelectorAll('.disable-on-submit').forEach((button) => {
    button.removeEventListener('click', disableOnSubmitHandler);
    button.addEventListener('click', disableOnSubmitHandler);
  });
  root.querySelectorAll('.disable-all-on-submit').forEach((button) => {
    button.removeEventListener('click', disableAllOnSubmitHandler);
    button.addEventListener('click', disableAllOnSubmitHandler);
  });
}

export default installDisableOnSubmit;
